import React, {useEffect, useState} from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import { makeStyles } from '@material-ui/core/styles';

import Copyright from '../dashboard/furniture/Copyright'
import GoogleBtn from './GoogleBtn';

import { Redirect } from 'react-router-dom';
import { useOvermind } from '../overmind';

import * as Sentry from "@sentry/react";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/random)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(20, 4),
    //marginTop: theme.spacing(8),
    //marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

  },
  footer: {
    alignItems: 'center',
    padding: theme.spacing(3, 2),
    marginTop: 'auto',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
  },
}));


export default function Login(){

  const classes = useStyles();
  const { state, actions } = useOvermind();

  const renderRedirect = () => {
    //console.log(state.loginRedirect)
    if (state.blockAccess === false) {
      return <Redirect to='/config'/>
    }
  }

  const getGoogleAccessToken = (authstate) => {
    actions.setGoogleAccessToken(authstate);
    actions.setActiveStep(1);
    actions.setBlockAccess(false);
    //console.log(JSON.stringify(state.authState))
  }

  useEffect(() => {

    if(typeof window.analytics.user ==='function'){
      Sentry.setContext("Segment Anonymous ID", {userId: window.analytics.user().anonymousId()});
    }
      Sentry.setContext("Cookie Enabled", {"enabled":navigator.cookieEnabled} );
  });

    return (
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image}>

        </Grid>
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>

            <Typography component="h1" variant="h5" align="center">
              Welcome to GTM Docs!
            </Typography>
            <Typography component="h1" variant="h5" align="center">
              To get started login with your Google Account
            </Typography>
            <Typography variant="subtitle1" align="center" color="error">
                {!navigator.cookieEnabled? "GTM Docs will not work properly if Cookies are Disabled":""}
            </Typography>



              <Box mt={5}>
               {renderRedirect()}
                <GoogleBtn label = "Sign in with Google" googleAccessToken={getGoogleAccessToken}/>
              </Box>
              <Box mt={5}>

                <footer className={classes.footer}>
                  <Container maxWidth="sm">
                    <Copyright />
                  </Container>
                </footer>
              </Box>

          </div>

        </Grid>
      </Grid>

    );
  }
